import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ValueOf } from '../../../types/base';
import { IconComponent } from '../../icon/icon.component';

export const progressBarStates = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  /** default value */
  INFO: 'info',
} as const;
export type ProgressBarState = ValueOf<typeof progressBarStates>;

export const progressBarModes = {
  /** default value */
  DETERMINATE: 'determinate',
  INDETERMINATE: 'indeterminate',
} as const;
export type ProgressBarMode = ValueOf<typeof progressBarModes>;

@Component({
  selector: 'evc-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  standalone: true,
  imports: [IconComponent, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  state = input<ProgressBarState>(progressBarStates.INFO);
  mode = input<ProgressBarMode>(progressBarModes.DETERMINATE);
  progressValue = input<number>(0);

  protected progressBarModes = progressBarModes;
}
